import React, { useState } from 'react'
import { data } from '../Assets/data';
import './Questions.css'
import { AnimatePresence, motion } from "motion/react"

const Questions = () => {

    let [index, setIndex] = useState(0);
    let [question, setQuestion] = useState(data[index]);

    let [finished, setFinished] = useState(false);

    let [clicked, setClicked] = useState(0);

    let [attributes, setAttributes] = useState([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]);

    let [array, setArray] = useState([]);

    const option1 = () => {
        attributes[index] = 0;
        setAttributes(attributes);
        setIndex(++index);
        setQuestion(data[index]);

        if(index === 16){
            setFinished(true);
            fetchData();
        }

        setClicked(clicked + 1);

        console.log(attributes);
    }

    const option2 = () => {
        attributes[index] = 2;
        setAttributes(attributes);
        setIndex(++index);
        setQuestion(data[index]);

        if(index === 16){
            setFinished(true);
            fetchData();
        }

        setClicked(clicked + 1);
        
        
        console.log(attributes);
    }

    const option3 = () => {
        attributes[index] = 4;
        setAttributes(attributes);
        setIndex(++index);
        setQuestion(data[index]);

        if(index === 16){
            setFinished(true);
            fetchData();
        }

        setClicked(clicked + 1);
        
        
        console.log(attributes);
    }

    const option4 = () => {
        attributes[index] = 6;
        setAttributes(attributes);
        setIndex(++index);
        setQuestion(data[index]);

        if(index === 16){
            setFinished(true);
            fetchData();
        }
        
        setClicked(clicked + 1);

        
        console.log(attributes);
    }

    const option5 = () => {
        attributes[index] = 8;
        setAttributes(attributes);
        setIndex(++index);
        setQuestion(data[index]);

        if(index === 16){
            setFinished(true);
            fetchData();
        }

        setClicked(clicked + 1);

        
        
        console.log(attributes);
    }

    const option6 = () => {
        attributes[index] = 10;
        setAttributes(attributes);
        setIndex(++index);
        setQuestion(data[index]);

        if(index === 16){
            setFinished(true);
            fetchData();
        }

        setClicked(clicked + 1);

        
        
        console.log(attributes);
    }

    const fetchData = async () => {
        try {
          const response = await fetch('https://compucar-return-r3o2u.ondigitalocean.app/run-script', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ values: attributes}), //, Replace with your request body, if needed
          });
      
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
      
          const output = await response.json();
          console.log(output)
          setArray([output.output[0], output.output[1], output.output[2], output.output[3], output.output[4], output.output[5],
                   output.output[6], output.output[7], output.output[8], output.output[9]]);
          console.log('Success:', output.output[0]);
          // Handle the response data here, e.g., update state, display data
        } catch (error) {
          console.error('Error:', error);
          // Handle errors here, e.g., display an error message to the user
        }
      };

      const rewind = () => {

        setIndex(0);
        setQuestion(data[0]);

        setFinished(false);

      }



  return (
    
    (finished === true) ? 
    
    <div className='list'>
        <ul>
        <motion.div key={clicked} initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{delay: 0.1}}>
            <h3>Your recommended cars are: </h3>
        </motion.div>

        <motion.div key={clicked+10} initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{delay: 0.2}}>
            <li>{array[0]}</li>
        </motion.div>
        <motion.div key={clicked+20} initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{delay: 0.3}}>
            <li>{array[1]}</li>
        </motion.div>
        <motion.div key={clicked+30} initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{delay: 0.4}}>
            <li>{array[2]}</li>
        </motion.div>
        <motion.div key={clicked+40} initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{delay: 0.5}}>
            <li>{array[3]}</li>
        </motion.div>
        <motion.div key={clicked+50} initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{delay: 0.6}}>
            <li>{array[4]}</li>
        </motion.div>
        <motion.div key={clicked+60} initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{delay: 0.7}}>
            <li>{array[5]}</li>
        </motion.div>
        <motion.div key={clicked+70} initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{delay: 0.8}}>
            <li>{array[6]}</li>
        </motion.div>
        <motion.div key={clicked+80} initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{delay: 0.9}}>
            <li>{array[7]}</li>
        </motion.div>
        <motion.div key={clicked+90} initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{delay: 1.0}}>
            <li>{array[8]}</li>
        </motion.div>
        <motion.div key={clicked+100} initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{delay: 1.1}}>
            <li>{array[9]}</li>
        </motion.div>
        
        <motion.div key={clicked+110} initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{delay: 1.2}}>
            <button onClick={rewind}>Back to beginning</button>
        </motion.div>
            
        </ul>
    </div> 
    : 
    <div className='Questions'>
        
        <motion.div
        key={clicked} initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{delay: 0.1}}>
            <h2>{question.question}</h2>
        </motion.div>

        <ul>
            <motion.div key={clicked} initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{delay: 0.2}} whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.8 }}>
                <li onClick={option1}>{question.option1}</li>
            </motion.div>
            <motion.div key={clicked+10} initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{delay: 0.3}} whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.8 }}>
                <li onClick={option2}>{question.option2}</li>
            </motion.div>
            <motion.div key={clicked+20} initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{delay: 0.4}} whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.8 }}>
                <li onClick={option3}>{question.option3}</li>
            </motion.div>
            <motion.div key={clicked+30} initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{delay: 0.5}} whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.8 }}>
                <li onClick={option4}>{question.option4}</li>
            </motion.div>
            <motion.div key={clicked+40} initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{delay: 0.6}} whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.8 }}>
                <li onClick={option5}>{question.option5}</li>
            </motion.div>
            <motion.div key={clicked+50} initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{delay: 0.7}} whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.8 }}>
                <li onClick={option6}>{question.option6}</li>
            </motion.div>
        </ul>

    </div>


    
  )
}

export default Questions